import { render, staticRenderFns } from "./unconference.vue?vue&type=template&id=659ee2a1&"
import script from "./unconference.vue?vue&type=script&lang=js&"
export * from "./unconference.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports